// src/data/proyectos.js
// Datos estructurados del Sistema Integrado ARCSEG v2.1

export const TIPOS_PROYECTO = [
  {
    id: 'hidraulica',
    nombre: 'Modelación Hidráulica de Redes',
    icono: '💧',
    color: '#1A2E44',
    duracion: '1-4 meses',
    software: 'WaterGEMS · SewerGEMS · AutoCAD',
    entregable: 'Modelo calibrado + planos + memoria de cálculo',
    fases: [
      { codigo: 'H0', nombre: 'Inicio y Diagnóstico', procesos: ['H0.1 Revisión info base', 'H0.2 Visita de campo', 'H0.3 Levantamiento topográfico', 'H0.4 Procesamiento SIG/MDT'] },
      { codigo: 'H1', nombre: 'Análisis de Red Existente', procesos: ['H1.1 Inventario de red', 'H1.2 Análisis de demanda', 'H1.3 Parámetros de diseño'] },
      { codigo: 'H2', nombre: 'Modelación Hidráulica', procesos: ['H2.1 Construcción del modelo', 'H2.2 Calibración y validación', 'H2.3 Simulación de escenarios', 'H2.4 Análisis de déficits'] },
      { codigo: 'H3', nombre: 'Diseño de la Solución', procesos: ['H3.1 Diseño de red', 'H3.2 Verificación hidráulica', 'H3.3 Presupuesto referencial'] },
      { codigo: 'H4', nombre: 'Documentación y Entrega', procesos: ['H4.1 Memoria técnica', 'H4.2 Planos finales', 'H4.3 Revisión QC interna', 'H4.4 Entrega formal al cliente'] },
    ],
    checklist: [
      { id: 'h1', texto: 'Cartografía y catastro de red existente', categoria: 'Datos de entrada' },
      { id: 'h2', texto: 'Datos de población y proyecciones demográficas', categoria: 'Datos de entrada' },
      { id: 'h3', texto: 'Datos operacionales: presiones y caudales medidos', categoria: 'Datos de entrada' },
      { id: 'h4', texto: 'Levantamiento topográfico del área de proyecto', categoria: 'Datos de entrada' },
      { id: 'h5', texto: 'Normas aplicables definidas (INEN / EPMAPS / GAD)', categoria: 'Parámetros de diseño' },
      { id: 'h6', texto: 'Dotación de diseño según tipo de usuario', categoria: 'Parámetros de diseño' },
      { id: 'h7', texto: 'Horizonte de diseño definido (años)', categoria: 'Parámetros de diseño' },
      { id: 'h8', texto: 'Presiones mínima y máxima de diseño', categoria: 'Parámetros de diseño' },
      { id: 'h9', texto: 'Velocidades mínima y máxima permitidas', categoria: 'Parámetros de diseño' },
      { id: 'h10', texto: 'Software de modelación seleccionado (WaterGEMS/SewerGEMS)', categoria: 'Herramientas' },
      { id: 'h11', texto: 'Modelo hidráulico calibrado con datos de campo', categoria: 'Modelación' },
      { id: 'h12', texto: 'Escenarios de simulación definidos con cliente', categoria: 'Modelación' },
      { id: 'h13', texto: 'Memoria de cálculo completa y firmada', categoria: 'Entregables' },
      { id: 'h14', texto: 'Juego de planos .dwg + .pdf en rotulación ARCSEG', categoria: 'Entregables' },
      { id: 'h15', texto: 'Presupuesto referencial con APU', categoria: 'Entregables' },
      { id: 'h16', texto: 'Revisión QC por segundo técnico completada', categoria: 'Control de calidad' },
    ]
  },
  {
    id: 'hidrologia',
    nombre: 'Modelación Hidrológica',
    icono: '🌊',
    color: '#2563EB',
    duracion: '1-3 meses',
    software: 'HEC-RAS · QGIS · Excel',
    entregable: 'Curvas IDF + caudales de diseño + mapas de inundación',
    fases: [
      { codigo: 'HG0', nombre: 'Definición y Datos Base', procesos: ['HG0.1 Revisión de alcance', 'HG0.2 Datos hidrometeorológicos', 'HG0.3 MDT y cartografía base'] },
      { codigo: 'HG1', nombre: 'Delimitación de Cuencas', procesos: ['HG1.1 Delimitación de cuencas', 'HG1.2 Parámetros morfométricos', 'HG1.3 Uso de suelo y CN'] },
      { codigo: 'HG2', nombre: 'Análisis Estadístico', procesos: ['HG2.1 Análisis de consistencia', 'HG2.2 Frecuencia de precipitaciones', 'HG2.3 Caudales de diseño'] },
      { codigo: 'HG3', nombre: 'Modelación Hidráulica Fluvial', procesos: ['HG3.1 Modelo HEC-RAS', 'HG3.2 Simulación de inundación', 'HG3.3 Análisis de riesgo'] },
      { codigo: 'HG4', nombre: 'Documentación y Entrega', procesos: ['HG4.1 Memoria hidrológica completa', 'HG4.2 Atlas cartográfico', 'HG4.3 Revisión QC y entrega'] },
    ],
    checklist: [
      { id: 'hg1', texto: 'Cartografía base 1:25.000 descargada', categoria: 'Datos de entrada' },
      { id: 'hg2', texto: 'Datos INAMHI: estaciones hidrometeorológicas identificadas', categoria: 'Datos de entrada' },
      { id: 'hg3', texto: 'Series de precipitación máxima anual (mínimo 20 años)', categoria: 'Datos de entrada' },
      { id: 'hg4', texto: 'MDE descargado (SRTM/ASF) o levantamiento propio', categoria: 'Datos de entrada' },
      { id: 'hg5', texto: 'Cuencas delimitadas y validadas en QGIS', categoria: 'Análisis' },
      { id: 'hg6', texto: 'Parámetros morfométricos calculados', categoria: 'Análisis' },
      { id: 'hg7', texto: 'Análisis de consistencia (doble masa) completado', categoria: 'Análisis' },
      { id: 'hg8', texto: 'Distribución probabilística seleccionada y ajustada', categoria: 'Análisis' },
      { id: 'hg9', texto: 'Curvas IDF construidas para los TR requeridos', categoria: 'Análisis' },
      { id: 'hg10', texto: 'Períodos de retorno de diseño definidos con cliente', categoria: 'Parámetros' },
      { id: 'hg11', texto: 'Modelo HEC-RAS construido y calibrado', categoria: 'Modelación' },
      { id: 'hg12', texto: 'Mapas de inundación generados por TR', categoria: 'Resultados' },
      { id: 'hg13', texto: 'Memoria hidrológica completa firmada', categoria: 'Entregables' },
      { id: 'hg14', texto: 'Atlas cartográfico con capas SIG (.shp)', categoria: 'Entregables' },
      { id: 'hg15', texto: 'My Maps publicado para el cliente', categoria: 'Entregables' },
    ]
  },
  {
    id: 'hidro_sanitario',
    nombre: 'Diseño Hidro-Sanitario',
    icono: '🏗️',
    color: '#0F766E',
    duracion: '2-6 meses',
    software: 'Revit MEP · WaterGEMS · AutoCAD',
    entregable: 'Modelo BIM + planos MEP + presupuesto + metrados',
    fases: [
      { codigo: 'HS0', nombre: 'Definición del Proyecto', procesos: ['HS0.1 Recepción planos arq.', 'HS0.2 Parámetros de diseño', 'HS0.3 Cuantificación de aparatos'] },
      { codigo: 'HS1', nombre: 'Diseño Agua Potable', procesos: ['HS1.1 Cálculo de demanda AP', 'HS1.2 Cisterna y cuarto de bombas', 'HS1.3 Red de distribución AP', 'HS1.4 Red contra incendios'] },
      { codigo: 'HS2', nombre: 'Aguas Residuales y Pluviales', procesos: ['HS2.1 Red de aguas servidas', 'HS2.2 Red de aguas lluvias', 'HS2.3 Trampa de grasas/PTAR'] },
      { codigo: 'HS3', nombre: 'Modelación BIM MEP', procesos: ['HS3.1 Modelo BIM hidro-sanitario', 'HS3.2 Clash detection', 'HS3.3 Metrados y especificaciones'] },
      { codigo: 'HS4', nombre: 'Presupuesto y Entrega', procesos: ['HS4.1 Presupuesto hidro-sanitario', 'HS4.2 Memoria técnica completa', 'HS4.3 Planos finales y modelo BIM', 'HS4.4 Entrega formal y portal'] },
    ],
    checklist: [
      { id: 'hs1', texto: 'Planos arquitectónicos .dwg recibidos y revisados', categoria: 'Datos de entrada' },
      { id: 'hs2', texto: 'Número de pisos y tipo de edificación definido', categoria: 'Datos de entrada' },
      { id: 'hs3', texto: 'Presión de red disponible en punto de acometida', categoria: 'Datos de entrada' },
      { id: 'hs4', texto: 'Cota de alcantarillado público verificada', categoria: 'Datos de entrada' },
      { id: 'hs5', texto: 'Normativa aplicada: NEC-HS + INEN', categoria: 'Parámetros' },
      { id: 'hs6', texto: 'Dotación de diseño por tipo de usuario definida', categoria: 'Parámetros' },
      { id: 'hs7', texto: 'Aparatos sanitarios inventariados por nivel', categoria: 'Diseño AP' },
      { id: 'hs8', texto: 'Cisterna dimensionada (volumen regulación + reserva CI)', categoria: 'Diseño AP' },
      { id: 'hs9', texto: 'Bomba seleccionada con curva del sistema', categoria: 'Diseño AP' },
      { id: 'hs10', texto: 'Red AP dimensionada y verificada en WaterGEMS', categoria: 'Diseño AP' },
      { id: 'hs11', texto: 'Red AA dimensionada por unidades de descarga', categoria: 'Diseño AA' },
      { id: 'hs12', texto: 'Red pluvial dimensionada con curvas IDF locales', categoria: 'Diseño AA' },
      { id: 'hs13', texto: 'Modelo BIM Revit MEP construido con LOD pactado', categoria: 'BIM' },
      { id: 'hs14', texto: 'Clash detection ejecutado y resuelto', categoria: 'BIM' },
      { id: 'hs15', texto: 'Metrados extraídos del modelo Revit', categoria: 'BIM' },
      { id: 'hs16', texto: 'Presupuesto APU por sistema (AP/AA/CI)', categoria: 'Entregables' },
      { id: 'hs17', texto: 'Modelo exportado a .ifc para entrega', categoria: 'Entregables' },
    ]
  },
  {
    id: 'plan_maestro',
    nombre: 'Planes Maestros AP/Saneamiento',
    icono: '🗺️',
    color: '#7C3AED',
    duracion: '3-8 meses',
    software: 'WaterGEMS · SewerGEMS · QGIS · Civil 3D',
    entregable: 'Plan de obras por etapa + atlas SIG + presupuesto',
    fases: [
      { codigo: 'PM0', nombre: 'Diagnóstico del Sistema', procesos: ['PM0.1 Recopilación de información', 'PM0.2 Visitas y aforos', 'PM0.3 Catastro e inventario', 'PM0.4 Análisis de cobertura'] },
      { codigo: 'PM1', nombre: 'Proyecciones y Demandas', procesos: ['PM1.1 Proyección demográfica', 'PM1.2 Demandas futuras', 'PM1.3 Horizontes de planificación'] },
      { codigo: 'PM2', nombre: 'Modelación Hidráulica', procesos: ['PM2.1 Modelo hidráulico actual', 'PM2.2 Diagnóstico hidráulico', 'PM2.3 Escenarios futuros por etapa'] },
      { codigo: 'PM3', nombre: 'Plan de Obras y Presupuesto', procesos: ['PM3.1 Plan de obras por etapa', 'PM3.2 Presupuesto por etapa', 'PM3.3 Tarifas y sostenibilidad'] },
      { codigo: 'PM4', nombre: 'Entrega del Plan Maestro', procesos: ['PM4.1 Informe final', 'PM4.2 Atlas cartográfico SIG', 'PM4.3 Presentación ejecutiva', 'PM4.4 Entrega formal'] },
    ],
    checklist: [
      { id: 'pm1', texto: 'Catastro de red existente disponible (planos + datos)', categoria: 'Diagnóstico' },
      { id: 'pm2', texto: 'Datos operacionales: presiones, caudales, cobertura', categoria: 'Diagnóstico' },
      { id: 'pm3', texto: 'Aforos en campo completados', categoria: 'Diagnóstico' },
      { id: 'pm4', texto: 'Catastro georreferenciado en QGIS', categoria: 'Diagnóstico' },
      { id: 'pm5', texto: 'Datos INEC para proyección demográfica', categoria: 'Proyecciones' },
      { id: 'pm6', texto: 'Horizonte de planificación definido (20-30 años)', categoria: 'Proyecciones' },
      { id: 'pm7', texto: 'Etapas de planificación validadas con cliente', categoria: 'Proyecciones' },
      { id: 'pm8', texto: 'Modelo WaterGEMS/SewerGEMS actual calibrado', categoria: 'Modelación' },
      { id: 'pm9', texto: 'Diagnóstico hidráulico presentado al cliente', categoria: 'Modelación' },
      { id: 'pm10', texto: 'Escenarios por etapa simulados', categoria: 'Modelación' },
      { id: 'pm11', texto: 'Plan de obras priorizado por etapa', categoria: 'Plan de obras' },
      { id: 'pm12', texto: 'Presupuesto APU por etapa completado', categoria: 'Plan de obras' },
      { id: 'pm13', texto: 'Análisis de sostenibilidad tarifaria (si aplica)', categoria: 'Plan de obras' },
      { id: 'pm14', texto: 'Informe del Plan Maestro firmado', categoria: 'Entregables' },
      { id: 'pm15', texto: 'Atlas SIG con capas por etapa publicado', categoria: 'Entregables' },
      { id: 'pm16', texto: 'Presentación ejecutiva ante GAD/cliente aprobada', categoria: 'Entregables' },
    ]
  },
  {
    id: 'informe_tecnico',
    nombre: 'Informes Técnicos y Memorias',
    icono: '📋',
    color: '#B45309',
    duracion: '2-8 semanas',
    software: 'HEC-RAS · WaterGEMS · AutoCAD · Excel',
    entregable: 'Memoria de cálculo firmada + planos de apoyo',
    fases: [
      { codigo: 'IT0', nombre: 'Definición y Alcance', procesos: ['IT0.1 Revisión de TDRs y alcance', 'IT0.2 Recopilación de datos'] },
      { codigo: 'IT1', nombre: 'Desarrollo Técnico', procesos: ['IT1.1 Cálculo técnico', 'IT1.2 Planos de apoyo', 'IT1.3 Redacción de la memoria'] },
      { codigo: 'IT2', nombre: 'Revisión y Control de Calidad', procesos: ['IT2.1 Revisión QC interna', 'IT2.2 Incorporación de observaciones', 'IT2.3 Aprobación y firma'] },
      { codigo: 'IT3', nombre: 'Entrega y Cierre', procesos: ['IT3.1 Entrega al cliente', 'IT3.2 Atención de observaciones', 'IT3.3 Encuesta y cierre'] },
    ],
    checklist: [
      { id: 'it1', texto: 'TDRs o solicitud del cliente recibida por escrito', categoria: 'Inicio' },
      { id: 'it2', texto: 'Alcance del informe acordado y confirmado', categoria: 'Inicio' },
      { id: 'it3', texto: 'Checklist de datos de entrada completado', categoria: 'Inicio' },
      { id: 'it4', texto: 'Normativa aplicable identificada', categoria: 'Desarrollo' },
      { id: 'it5', texto: 'Cálculos técnicos desarrollados y verificados', categoria: 'Desarrollo' },
      { id: 'it6', texto: 'Planos de apoyo con rotulación ARCSEG', categoria: 'Desarrollo' },
      { id: 'it7', texto: 'Memoria redactada: antecedentes + metodología + resultados', categoria: 'Desarrollo' },
      { id: 'it8', texto: 'Revisión QC cruzada por segundo técnico', categoria: 'Control de calidad' },
      { id: 'it9', texto: 'Observaciones QC incorporadas', categoria: 'Control de calidad' },
      { id: 'it10', texto: 'Informe firmado y sellado por Dir. Técnico', categoria: 'Aprobación' },
      { id: 'it11', texto: 'Informe entregado y subido a Drive del proyecto', categoria: 'Entrega' },
      { id: 'it12', texto: 'Portal Sites actualizado', categoria: 'Entrega' },
      { id: 'it13', texto: 'Encuesta de satisfacción enviada al cliente', categoria: 'Cierre' },
    ]
  },
  {
    id: 'construccion',
    nombre: 'Proyectos de Construcción',
    icono: '🏢',
    color: '#DC2626',
    duracion: '6-24 meses',
    software: 'Revit · AutoCAD · Civil 3D · AppSheet',
    entregable: 'Planos constructivos + fiscalización + liquidación',
    fases: [
      { codigo: 'C1-C4', nombre: 'Ingeniería y Arranque', procesos: ['C.1 Ingeniería de detalle', 'C.2 Permisos y aprobaciones', 'C.3 Contratación de obra', 'C.4 Arranque de obra'] },
      { codigo: 'C5-C7', nombre: 'Ejecución de Obra', procesos: ['C.5 Ejecución y supervisión', 'C.6 Control de costos', 'C.7 Pruebas y ensayos'] },
      { codigo: 'C8-C10', nombre: 'Cierre y Liquidación', procesos: ['C.8 Recepción provisional', 'C.9 Liquidación de obra', 'C.10 Recepción definitiva'] },
    ],
    checklist: [
      { id: 'c1', texto: 'Juego de planos constructivos completos aprobados', categoria: 'Ingeniería' },
      { id: 'c2', texto: 'Especificaciones técnicas generales (ETG) elaboradas', categoria: 'Ingeniería' },
      { id: 'c3', texto: 'APU por partida aprobado', categoria: 'Ingeniería' },
      { id: 'c4', texto: 'Permisos municipales obtenidos', categoria: 'Permisos' },
      { id: 'c5', texto: 'Contrato de obra firmado con cronograma de hitos', categoria: 'Contratación' },
      { id: 'c6', texto: 'Acta de inicio firmada', categoria: 'Arranque' },
      { id: 'c7', texto: 'Plan SSO aprobado', categoria: 'Arranque' },
      { id: 'c8', texto: 'Bitácora de obra abierta', categoria: 'Arranque' },
      { id: 'c9', texto: 'AppSheet configurado para registro de campo', categoria: 'Ejecución' },
      { id: 'c10', texto: 'Informes semanales de avance activos', categoria: 'Ejecución' },
      { id: 'c11', texto: 'Módulo de costos Sheets activo (01-07 hojas)', categoria: 'Control costos' },
      { id: 'c12', texto: 'Desviación costos < 5% verificada semanalmente', categoria: 'Control costos' },
      { id: 'c13', texto: 'Ensayos de laboratorio completados y aprobados', categoria: 'Pruebas' },
      { id: 'c14', texto: 'Acta de recepción provisional firmada', categoria: 'Cierre' },
      { id: 'c15', texto: 'Liquidación económica con contratistas completada', categoria: 'Cierre' },
      { id: 'c16', texto: 'Acta definitiva firmada + garantías técnicas entregadas', categoria: 'Cierre' },
    ]
  }
];

export const ESTADOS_PROYECTO = ['Propuesta', 'Activo', 'En revisión', 'Entregado', 'Cerrado'];
export const RESPONSABLES = ['Mgtr. Luis Segovia', 'Ing. Luis Segovia', 'Ing. Stefany Segovia', 'Admin Info'];
